module.exports = __webpack_public_path__ + "img/selected1-min.e3a41c8e.png";